<script lang="ts">
    import CharityList from '../../components/admin/charity/charityList.svelte';
  </script>
  
  <div class="donation-list-page">
    <CharityList />
  </div>
  
  <style>
    .donation-list-page {
      min-height: 100vh;
      background-color: #f9fafb;
    }
  </style>  